import { Record } from "immutable";
import moment from "moment";
import { DEVICE_DATA_LATENCIES, DEVICE_NETWORK_STATUES, DEVICE_TYPES } from "src/infinode/constants/device";
import { DEVICE_SERVICE_STATUES } from "src/infinode/constants/deviceService";
import { LANGUAGES } from "src/infinode/constants/languages";
import { createDeviceConfigRecord } from "./DeviceConfigRecord";

const DeviceRecord = Record({
  id: null,
  key: null,
  name: null,
  // The physical device ID
  deviceId: "",
  serialNumber: "",
  deviceModel: "",
  circuit1Name: "",
  circuit2Name: "",
  circuit3Name: "",
  circuit4Name: "",
  circuit5Name: "",
  circuit6Name: "",
  circuit123Name: "",
  circuit456Name: "",
  isPaired: false,
  pairingCodeExpiresSeconds: 0,
  addedDate: moment(),
  // Configuration
  deviceConfig: null,

  // Below are reserved attributes.
  // May use in the future
  siteID: null,
  site:"",
  assignedZone:"",
  password: "",
  deviceType: DEVICE_TYPES.OTHER,
  networkStatus: DEVICE_NETWORK_STATUES.OFFLINE,
  networkType: null,
  networkServiceProvider: "",
  networkSignalStrength: null,
  nodeID:null,
  nodePortLv1:null,
  nodePortLv2:null,
  modbusAddrOrUnit:null,
  nodeType:null,
  firmware: null,
  serviceStatus: DEVICE_SERVICE_STATUES.NONE,
  displayLanguage: LANGUAGES.ENGLISH,
  dataLatency: DEVICE_DATA_LATENCIES.FOUR_HOURS,
  // sldRole:null,
  // sldRoleLastUpdatedTsSec:null,
  // //control logic related idlc3000 and idlc3000_smartct
  // allowedDemand:null,
  // ratedPV :null,
  // ismaster :null,
  // masterGlobalUniqueID :null,
  // heartbeatInterval :null,
  ethIPV4 :null,
  ethSubnet :null,
  ethGateway :null,
  modbusTCPPort :null,
  modbusTCPTimeout :null,
  // wiringU :null,
  // wiringI :null,
  // InSource :null,
  // PTPrimary :null,
  // PTPrimaryUnit :null,
  // PTSecondary:null,
  // CT113Primary:null,
  // CT113Secondary :null,
  // CT113Reverse:null,
  // CT2Primary :null,
  // CT2Secondary: null,
  // CT2Reverse: null,
  // CT3Primary: null,
  // CT3Secondary: null,
  // CT3Reverse: null,
  // CTInPrimary: null,
  // CTInSecondary: null,
  // CTInReverse: null,
  // mainCircuit: null,
  // rs485Baudrate: null,
  // rs485Parity: null,
  // rs485Stopbit: null,
  dispBrightness: null,
  dispContrast: null,
  dispSymbol: null,
  // demandLimit: null,
  // demandUnit: null,
  // demandSafeMargin: null,
  // smartLoadLowOffset: null,
  // smartLoadUnit: null,
  // // smartLoadSafeMargin: null,
  // loadEnableMask: null,
  // evChargerEnableMask: null,
  // demandControlSequence: null,
  // smartLoadSequence: null,
  // smartLoadTurnOffThresholdMask: null,
  // smartLoad1TurnOffThreshold: null,
  // smartLoad2TurnOffThreshold: null,
  // smartLoad3TurnOffThreshold: null,
  // smartLoad4TurnOffThreshold: null,
  // smartLoad5TurnOffThreshold: null,
  // demandControlDecisionTime: null,
  // smartLoaddecisionTime: null,
  // exportLimit: null,
  // exportUnit: null,
  // exportSafeMargin: null,
  // sldRole: null,
  // sldRoleLastUpdatedTsSec: null,
  // loadDeadBandFactor: null,
  // mainCircuitAllocationLevel1: null,
  // mainCircuitAllocationLevel2: null,
  // load1CircuitAllocationLevel1: null,
  // load1CircuitAllocationLevel2: null,
  // load1RatedkW: null,
  // load1RatedkVA: null,
  // load2CircuitAllocationLevel1: null,
  // load2CircuitAllocationLevel2: null,
  // load2RatedkW: null,
  // load2RatedkVA: null,
  // load3CircuitAllocationLevel1: null,
  // load3CircuitAllocationLevel2: null,
  // load3RatedkW: null,
  // load3RatedkVA: null,
  // load4CircuitAllocationLevel1: null,
  // load4CircuitAllocationLevel2: null,
  // load4RatedkW: null,
  // load4RatedkVA: null,
  // solar1Brand: null,
  // solar1Model: null,
  // solar1FirmwareVersion: null,
  // solar1AddrIPV4: null,
  // solar1AddrSerial: null,
  // solar1Port: null,
  // solar1Protocol: null,
  // solar1CircuitAllocationLevel1: null,
  // solar1CircuitAllocationLevel2: null,
  // solar1RatedkW: null,
  // solar1RatedkVA: null,
  // solar1Setpoint: null,
  // solar1SetpointUnit: null


});

const createDeviceRecord = (device, isPaired = true, pairingCodeExpiresSeconds = 0) => {
  let record = DeviceRecord(device);
  record = record.withMutations(rm => {
    rm.update("name", n => n || "");
    // rm.set("isPaired", isPaired);
    // rm.set("pairingCodeExpiresSeconds", pairingCodeExpiresSeconds);
    if (device.deviceConfig) {
      rm.set("deviceConfig", createDeviceConfigRecord(device.deviceConfig));
    }
  });
  return record;
};

export { createDeviceRecord };

export default DeviceRecord;
